import { render, staticRenderFns } from "./SP_Insurances.vue?vue&type=template&id=97f4470c"
import script from "./SP_Insurances.vue?vue&type=script&lang=js"
export * from "./SP_Insurances.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports